const CurrentUserDetailsActionConstants = {
  UPDATE_CURRENT_USER_METADATA: "UserDetails/UPDATE_CURRENT_USER_METADATA",
  UPDATED_CURRENT_USER_METADATA: "UserDetails/UPDATED_CURRENT_USER_METADATA",
  LOAD_USER_AFFINITY: "UserDetails/LOAD_USER_AFFINITY",
  LOADING_USER_AFFINITY: "UserDetails/LOADING_USER_AFFINITY",
  LOADED_USER_AFFINITY: "UserDetails/LOADED_USER_AFFINITY",
  LOAD_EXPERIMENTATION_GROUP: "UserDetails/LOAD_USER_EXP_GROUP",
  LOADING_EXPERIMENTATION_GROUP: "UserDetails/LOADING_USER_EXP_GROUP",
  LOADED_EXPERIMENTATION_GROUP: "UserDetails/LOADED_USER_EXP_GROUP"
};
export {
  CurrentUserDetailsActionConstants as default
};
//# sourceMappingURL=CurrentUserDetailsActionsConstants.js.map
